import React from 'react';

import MinimalLayoutWithData from '../components/shared/MinimalLayoutWithData';
import PlayerAccountData from '../components/widgets/PlayerAccountData';
import DeletePageBottom from '../components/widgets/DeletePageBottom';
import DeletePageTop from '../components/widgets/DeletePageTop';

const DeleteAccount = () => (
    <MinimalLayoutWithData>
        <DeletePageTop />
        <PlayerAccountData />
        <DeletePageBottom />
    </MinimalLayoutWithData>
);

export default DeleteAccount;
